import React, { useEffect, useState } from "react";
import { Context } from "../../../config/store";
import splitCamelCase from "../../../common/splitCamelCase";
import CheckStatusModal from "../../../components/Portfolio/CheckStatusModal/CheckStatusModal";
import './status.css'
const LeadStatus = ({ row, field }) => {
  const [showStatusModal, setShowStatusModal] = useState(false)
  const lenderToSkip = process.env.REACT_APP_SKIP_LENDER_STATUS
    ? process.env.REACT_APP_SKIP_LENDER_STATUS.split(",")
    : [];
  const { state } = React.useContext(Context);

  const [isUnassigned, setIsAssigned] = useState(false);

  useEffect(() => {
    (row?.assigned_lenders || []).map((item) => {
      if (item?.da_batch_id === 0) {
        setIsAssigned(true)
      }
    })
  }, [])

  return (
    <span>
      {state.userType === "admin" && row.status ? (
        row.assigned_lenders.length ?
          <div className="checkStatusBtn">
            <a
              onClick={() => { setShowStatusModal(true) }}
            >
              Check Status
            </a>
          </div>
          : <span className="">Unassigned</span>
      ) : (
        <span prop={(row?.assigned_lenders)}>
          {row?.assigned_lenders?.[0]?.cl_lender_id
            ? lenderToSkip.indexOf(
              String(row.assigned_lenders?.[0]?.cl_lender_id) ||
              row.assigned_lenders?.[0]?.cl_lender_id
            ) < 0
              ? row?.assigned_lenders?.[0]?.cl_status?.admin_status
                ? splitCamelCase(
                  row?.assigned_lenders?.[0]?.cl_status?.admin_status
                )
                : ""
              : ""
            : ""}
        </span>
      )}

      {showStatusModal && (
        <CheckStatusModal
          show={showStatusModal}
          close={() => { setShowStatusModal(false) }}
          statusList={row?.assigned_lenders}
        />
      )}
    </span>
  );
};

export default LeadStatus;
